import { FeatureToggleV2Service } from "@gtmhub/featureToggle";
import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { SubNavOption } from "@webapp/navigation/models/sub-nav-options.models";

@Component({
  selector: "gh-settings-sub-navigation",
  templateUrl: "./settings-sub-navigation.component.html",
})
export class SettingsSubNavigationComponent implements OnInit {
  @Output() titleChange = new EventEmitter<string>();

  public indicators: {
    loading?: boolean;
  } = { loading: true };

  public systemOptions: SubNavOption[] = [
    { label: "Methodology", icon: "map", state: "gtmhub.configuration.methodology" },
    { label: "Features", icon: "wizard", state: "gtmhub.configuration.features" },
    { label: "Custom Fields", icon: "drag-drop", state: "gtmhub.configuration.customFields" },
    { label: "Insightboard Parameters", icon: "custom-field", state: "gtmhub.configuration.parameters" },
    { label: "Automation", icon: "automation", state: "gtmhub.automationList" },
  ];
  public usersOptions: SubNavOption[] = [
    { label: "Users", icon: "users-group", state: "gtmhub.usersList" },
    { label: "Badges", icon: "award", state: "gtmhub.badges" },
    { label: "Manage Roles", icon: "live-demo", state: "gtmhub.roles" },
  ];
  public integrationsOptions: SubNavOption[] = [
    { label: "Data Sources", icon: "sql", state: "gtmhub.dataflow" },
    { label: "Installed Apps", icon: "integrations", state: "gtmhub.configuration.pluginList" },
    { label: "API Tokens", icon: "key", state: "gtmhub.configuration.apiTokens" },
    { label: "Slack", icon: "slack", state: "gtmhub.configuration.slack" },
    { label: "Jira", icon: "jira", state: "gtmhub.configuration.jira" },
    { label: "Workday", icon: "workday", state: "gtmhub.configuration.workday" },
  ];
  public accountOptions: SubNavOption[] = [
    { label: "Account and Domain", icon: "public", state: "gtmhub.configuration.accountNameDomainChange" },
    { label: "Branding", icon: "branding", state: "gtmhub.configuration.branding" },
    { label: "Billing", icon: "credit-card", state: "gtmhub.configuration.billing" },
    { label: "Single Sign On", icon: "security", state: "gtmhub.configuration.singleSignOn" },
  ];
  private sectionTitle = "Settings";

  constructor(private featureToggleService: FeatureToggleV2Service) {}
  ngOnInit(): Promise<void> {
    this.titleChange.emit(this.sectionTitle);
    return this.addTabsIfSessionMethodologyEnabled();
  }

  private async addTabsIfSessionMethodologyEnabled(): Promise<void> {
    try {
      const methodologyPerSessionFeatureEnabled = await this.featureToggleService.isFeatureAvailable("methodology-per-session");

      if (methodologyPerSessionFeatureEnabled) {
        // these two options should be moved in the initialization of systemOptions once we release the feature
        const featureOptions = [
          { label: "Language", icon: "public", state: "gtmhub.configuration.language" },
          { label: "Reports and Notifications", icon: "notifications", state: "gtmhub.configuration.reportsAndNotifications" },
        ];
        this.systemOptions.splice(1, 0, ...featureOptions);
      }
    } finally {
      delete this.indicators.loading;
    }
  }
}
